var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wait-audit", style: { height: _vm.viewportHeight } },
    [
      _c("HomeHeader", { attrs: { "scroll-top": "300" } }),
      _c("div", { staticClass: "flex-column container w-wrapper" }, [
        _c("div", { staticClass: "flex-column main" }, [
          _c("div", { staticClass: "title" }, [_vm._v("企业MCN机构申请")]),
          _c(
            "div",
            { staticClass: "steps-box" },
            [
              _c(
                "el-steps",
                { attrs: { active: 4, "align-center": "" } },
                [
                  _c("el-step", { attrs: { title: "选择公会类型" } }),
                  _c("el-step", { attrs: { title: "填写公会信息" } }),
                  _c("el-step", { attrs: { title: "填写资质信息" } }),
                  _c("el-step", { attrs: { title: "确认信息" } }),
                  _c("el-step", { attrs: { title: "等待审核" } }),
                  _c("el-step", { attrs: { title: "完成入驻" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.applyStatus === 1
            ? _c("div", { staticClass: "flex-column-center form-box" }, [
                _c("img", {
                  staticClass: "img-status",
                  attrs: {
                    src: require("@/assets/apply/submit-success.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "title-status" }, [
                  _vm._v("提交成功"),
                ]),
                _c("div", { staticClass: "dec" }, [
                  _vm._v(
                    "入驻申请提交成功，工作人员将在1-3个工作日内与您联系，请留意！"
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "edit-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.goUpdateForm()
                          },
                        },
                      },
                      [_vm._v("修改资料")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.applyStatus === 3
            ? _c("div", { staticClass: "flex-column-center form-box" }, [
                _c("img", {
                  staticClass: "img-status",
                  attrs: {
                    src: require("@/assets/apply/audit-fail.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "title-status" }, [
                  _vm._v("资质信息审核未通过"),
                ]),
                _c("div", { staticClass: "dec" }, [
                  _c("span", [
                    _vm._v(
                      "很抱歉，你提交的MCN机构入驻资料审核未通过，理由为："
                    ),
                  ]),
                  _c("span", { staticStyle: { color: "#f56c6c" } }, [
                    _vm._v(_vm._s(_vm.applyDetail.reason)),
                  ]),
                ]),
                _c("div", { staticClass: "dec" }, [
                  _vm._v("如有需要，请联系平台客服。你可以修改资料重新入职"),
                ]),
                _c(
                  "div",
                  { staticClass: "edit-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.goUpdateForm()
                          },
                        },
                      },
                      [_vm._v("修改资料")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }